import { ExportOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import Table, { ColumnsType } from 'antd/es/table'
import React, { FunctionComponent, useMemo } from 'react'

import { SeznamRegistraci } from '../../../common/aresTypes'
import { getAresSeznamRegistraci } from '../../utils/aresSearchIcoHelpers'
import { stringSorter } from '../../utils/generalTableHelpers'
import { useColumnFilters } from '../../utils/useColumnFilters'

export interface AresSearchIcoRegistersTableProps {
  ico?: string
  data?: SeznamRegistraci
  fetching?: boolean
}

interface AresSearchIcoTableItem {
  key: keyof SeznamRegistraci
  shortcut: string
  register: string
  state: string
  url: string
}

export const AresSearchIcoRegistersTable: FunctionComponent<AresSearchIcoRegistersTableProps> =
  props => {
    const { searchFilter } = useColumnFilters<AresSearchIcoTableItem>()

    const dataSource = useMemo(() => {
      if (!props.ico || !props.data) return []
      return getAresSeznamRegistraci(props.ico, props.data)
    }, [props.data, props.ico])

    const columns = useMemo<ColumnsType<AresSearchIcoTableItem>>(
      () => [
        {
          title: 'Zkratka',
          dataIndex: 'shortcut',
          sorter: stringSorter('shortcut'),
        },
        {
          title: 'Název registru',
          dataIndex: 'register',
          sorter: stringSorter('register'),
          ...searchFilter('register'),
        },
        {
          title: 'Stav',
          dataIndex: 'state',
          defaultSortOrder: 'ascend',
          sorter: stringSorter('state'),
          render: (state: string) => {
            const [text, color] =
              state === 'AKTIVNI'
                ? ['Nalezeno', 'green']
                : state === 'ZANIKLY'
                ? ['Zaniklý', 'orange']
                : ['Nenalezeno', 'default']
            return <Tag color={color}>{text}</Tag>
          },
        },
        {
          title: 'Akce',
          dataIndex: 'state',
          key: 'action',
          render: (state, record: AresSearchIcoTableItem) =>
            state === 'NEEXISTUJICI' ? (
              <span className="text-gray-400">---</span>
            ) : (
              <a
                href={record.url}
                target="_blank"
                rel="noopener noreferrer"
                title="Přejít na registr v novém okně"
              >
                Otevřít <ExportOutlined />
              </a>
            ),
        },
      ],
      [searchFilter]
    )

    return (
      <Table
        size="small"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={props.fetching}
      />
    )
  }
